import React from 'react';
import { Button, FormControl, FormGroup } from 'react-bootstrap';
import { getOrgTermsContent } from '../../content/utils.js';
import AuthorizedAction from '../AuthorizedAction.js';
import { PlusButtonIcon } from '../icons/PlusButtonIcon.jsx';
import SubHeader from '../SubHeader.jsx';
import styles from './FileSearch.module.css';

const FileSearch = ({
  count,
  handleSearch,
  query,
  initiative,
  project,
  navigateToNewFile,
}) => {
  const RenderNewFileLink = ({ children }) =>
    initiative ? (
      <AuthorizedAction
        action="create"
        subject={`${initiative.type}Initiative`}
      >
        {children}
      </AuthorizedAction>
    ) : (
      children
    );

  return (
    <SubHeader small>
      <div>
        <FormGroup bsClass="flex flex-justify">
          <div className={`flex ${styles.horizontalLabel}`}>
            <h2 className={styles.horizontalLabel}>Linked Files</h2>
            <strong className=" bordered text-muted">
              Total:&nbsp;
              <span className="text-primary">{count}</span>
            </strong>
          </div>
          <div className="flex flex-1 flex-end">
            <FormControl
              style={{ maxWidth: '540px' }}
              id="search"
              name="search"
              type="text"
              placeholder="Search..."
              className="search-icon m-r-30"
              onChange={handleSearch}
              value={query}
            />

            {(project &&
              initiative &&
              initiative.project[
                `manage${initiative.type.charAt(0).toUpperCase() + initiative.type.slice(1)}Initiatives`
              ]) ||
            (project && project.manageProjectEntities) ? (
              project.archived ? (
                <Button
                  onClick={() =>
                    window.alert(getOrgTermsContent('archivedProjectMessage'))
                  }
                  bsStyle="success"
                >
                  <PlusButtonIcon />
                  Add Linked File
                </Button>
              ) : (
                <Button bsStyle="success" onClick={navigateToNewFile}>
                  <PlusButtonIcon />
                  Add Linked File
                </Button>
              )
            ) : null}
          </div>
        </FormGroup>
      </div>
    </SubHeader>
  );
};

export default FileSearch;
